/* eslint-disable prettier/prettier */
// source: https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/
const body = document.querySelector('body');
let scrollPosition = 0;

export default {
  lock() {
    scrollPosition = window.scrollY;
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollPosition}px`;
    body.style.width = '100%';
    body.classList.add('scrolling--locked');
  },
  unlock() {
    body.style.removeProperty('overflow');
    body.style.removeProperty('position');
    body.style.removeProperty('top');
    body.style.removeProperty('width');
    body.classList.remove('scrolling--locked');

    // scroll back to position where we started before lock
    window.scrollTo(0, scrollPosition);
  },
};
